import {
  ProductPrice,
  Products,
  ProductsFilters,
  ProductsList,
} from '../../types';

export type ProductShared = Products.Product;

export type CatalogProductShared = Products.CatalogProductItem;

export type ProductPriceShared = ProductPrice;

export const ProductSharedPages = Products.Pages;

export type ProductsFiltersShared = ProductsFilters;

export type ProductsListShared = ProductsList;
